<template>
    <div class="choice-message choice-message-center" v-if="format === 'sendMessage'">
        <p class="send-chat-message">Send besked</p>
        <p class="chat-message" v-html="messageHtml"/>
    </div>
    <div class="choice-message" v-else v-html="messageHtml"/>
</template>

<script>
    import {TextUtil} from '../../utils/TextUtil'

    export default {
        name: 'choice-message',
        props: {
            format: {
                type: String,
                required: true
            },
            message: {
                type: String,
                required: true
            }
        },
        computed: {
            messageHtml() {
                return TextUtil.replaceEmojisInText(this.message);
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "~@less/font-sizes.less";

    .choice-message {
        &.choice-message-center {
            margin: 0 auto 0 auto;
        }

        .send-chat-message {
            margin-bottom: 5px;
            font-size: @app-font-size-send-chat-message;
        }

        .chat-message {
            background: #0084ff;
            color: white;
            padding: 10px;
            border-radius: 10px;
            font-size: @app-font-size-chat-message;
            text-align: center;
            margin: 0;
        }
    }
</style>